import { BudgetBys } from 'business/constants';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
    NO_GESTIONNAIRE,
    NO_SERVICE,
} from 'routes/BudgetModule/config/constants';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

/**
 * Custom hook to fetch a resource name depending on its software id.
 */
export const useGetResourceName = ({
    softwareId,
    budgetProposalId,
    by,
    enabled,
}: {
    softwareId: string;
    budgetProposalId: number;
    by: BudgetBys;
    enabled: boolean;
}): UseQueryResult<string, HttpError> =>
    useQuery({
        queryKey: ['resource', budgetProposalId, softwareId],

        queryFn: async () => {
            const response = await RQAPICallWithData<{ name: string }>({
                endpoint: `budget/common/${budgetProposalId}/${softwareId}`,
                method: 'GET',
            });

            return (
                response.content.data.name ??
                (by === BudgetBys.GESTIONNAIRE ? NO_GESTIONNAIRE : NO_SERVICE)
            );
        },

        enabled,
    });
